interface UsageLimitOverlayProps {
  isOpen: boolean;
  usageData?: unknown;
  variant: "no_subscription" | "upgrade_plan";
  onClose: () => void;
  onSubscribe: () => void;
}

export function UsageLimitModal({
  isOpen,
  onSubscribe,
}: UsageLimitOverlayProps) {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-slate-50/90 backdrop-blur-sm">
      <div className="text-center space-y-4 max-w-sm px-6">
        <p className="text-lg font-semibold text-gray-900">
          Abonnement requis
        </p>
        <p className="text-sm text-gray-600">
          Un abonnement est requis pour continuer à utiliser l'assistant IA.
        </p>
        <button
          onClick={onSubscribe}
          className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-white bg-default-600 rounded-lg hover:bg-default-700 transition-colors"
        >
          Voir les offres
        </button>
      </div>
    </div>
  );
}
